import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import jgiTrainee from "../../Assets/ExtraCurricular/jitinternship.png";
import fsdWorkshop from "../../Assets/ExtraCurricular/jitworkshop.png";
import aventusVolunteer from "../../Assets/ExtraCurricular/aventus2.0.jpeg";
import aventusTechLead from "../../Assets/ExtraCurricular/aventus3.0.png";
import ideahiveJudge from "../../Assets/hero2.jpeg";
import TypeWriter from "../TypeWriter";
import TabWindow from "../TabWindow";

function ExtraCurricular() {
  const cards = [
    {
      tag: "01_JGI_TRAINEE",
      title: "Trainee — FSD, ML & DSA Mentor",
      org: "Jain Group of Institutions (JGI), Davangere",
      year: "2025 – Present",
      desc: "Mentoring students in Full Stack Development, Machine Learning, and DSA through hands-on, real-world projects.",
      img: jgiTrainee,
    },
    {
      tag: "02_FSD_WORKSHOP",
      title: "Technical Trainer — 5-Day FSD Workshop",
      org: "Jain Institute of Technology, Davanagere",
      year: "2025",
      desc: "Trained participants in a 5-day hands-on Full Stack Development workshop, frontend to deployment.",
      img: fsdWorkshop,
    },
    {
      tag: "03_IDEAHIVE_JUDGE",
      title: "Judge — IdeaHive 3.0",
      org: "IdeaHive",
      year: "2025",
      desc: "Evaluated student ideas for innovation and feasibility, giving feedback to sharpen their concepts.",
      img: ideahiveJudge,
      bgPosition: "center 12%",
    },
    {
      tag: "04_AVENTUS_TECH_LEAD",
      title: "Tech Lead",
      org: "Aventus 3.0 Hackathon",
      year: "2025",
      desc: "Led technical operations and support for the hackathon, end to end.",
      img: aventusTechLead,
    },
    {
      tag: "05_AVENTUS_VOLUNTEER",
      title: "Volunteer",
      org: "Aventus 2.0 Hackathon",
      year: "2024",
      desc: "Supported event operations and participant coordination.",
      img: aventusVolunteer,
    },
  ];

  return (
    <Container fluid className="extra-section" id="extracurricular">
      <TabWindow
        activeTabId="leadership"
        activeFileName="leadership.md"
        activeIcon="⚡"
        language="MARKDOWN"
        lineCount="98"
      >
        <p className="terminal-cmd section-cmd">
          <span className="terminal-dollar">$</span>
          <TypeWriter text=' git log --grep="leadership"' speed={40} />
        </p>
        <h1 className="project-heading" style={{ textAlign: "center", marginBottom: "50px" }}>
          <TypeWriter text="Extracurricular Experience & " speed={45} cursor={false} />
          <TypeWriter text="Leadership" speed={45} className="purple" tag="strong" />
        </h1>
        <Row className="g-0" style={{ justifyContent: "center" }}>
          {cards.map((card, i) => (
            <Col md={6} lg={6} sm={12} key={i} className="extra-card-col">
              <div
                className="extra-card"
                style={{
                  backgroundImage: `url(${card.img})`,
                  backgroundPosition: card.bgPosition || "center",
                }}
              >
                <div className="extra-card-scrim" />
                <span className="extra-card-tag">
                  <span className="tag-chevron">&gt;</span> {card.tag}
                </span>
                <div className="extra-card-content">
                  <h4 className="extra-card-title">{card.title}</h4>
                  <div className="extra-card-meta">
                    <span className="purple">{card.org}</span>
                    <span className="extra-card-year"> | {card.year}</span>
                  </div>
                  <p className="extra-card-desc">{card.desc}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </TabWindow>
    </Container>
  );
}

export default ExtraCurricular;
